import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Document from '../../entities/document';
import Firm from '../../entities/firm';
import Identification from '../../entities/identification';
export function deleteDocument(document: Document, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = document.id;}
const _work = workingSet();
store.getState().firms.getMappingFor('logo', document.id).filter(firmTemp => firmTemp.status !== 'D').forEach(firmTemp => {
const _firm = ((_work.get('firm:' + firmTemp.id) ?? firmTemp) as Firm).clone();
_firm.status = 'U';
_firm.addedOn = newHRTimestamp();
_firm.addedBy = getCurrentUserId();
_firm.importSource = targetImportSource;
_firm.importId = mergeId;
if (_firm.logo === document.id) {
_firm.logo = null;

}
_work.set('firm:' + _firm.id, _firm);
store.dispatch(Actions.FirmActions.saveFirmQueue(_firm));
});
store.getState().identifications.getMappingFor('attachments', document.id).filter(identificationTemp => identificationTemp.status !== 'D').forEach(identificationTemp => {
const _identification = ((_work.get('identification:' + identificationTemp.id) ?? identificationTemp) as Identification).clone();
_identification.status = 'U';
_identification.addedOn = newHRTimestamp();
_identification.addedBy = getCurrentUserId();
_identification.importSource = targetImportSource;
_identification.importId = mergeId;
_identification.attachments = _identification.attachments?.filter(id => id !== document.id) || [];

_work.set('identification:' + _identification.id, _identification);
store.dispatch(Actions.IdentificationActions.saveIdentificationQueue(_identification));
});



document.status = 'D';
document.addedOn = newHRTimestamp();
document.addedBy = getCurrentUserId();
document.importSource = targetImportSource;
document.importId = mergeId;
store.dispatch(Actions.DocumentActions.removeDocumentQueue(document));
}
export function replaceDocument(document: Document, replaceWith: Document, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = document.id;}
const _work = workingSet();
store.getState().firms.getMappingFor('logo', document.id).filter(firmTemp => firmTemp.status !== 'D').forEach(firmTemp => {
const _firm = ((_work.get('firm:' + firmTemp.id) ?? firmTemp) as Firm).clone();
_firm.status = 'U';
_firm.addedOn = newHRTimestamp();
_firm.addedBy = getCurrentUserId();
_firm.importSource = targetImportSource;
_firm.importId = mergeId;
if (_firm.logo === document.id) {
_firm.logo = replaceWith.id;

}
_work.set('firm:' + _firm.id, _firm);
store.dispatch(Actions.FirmActions.saveFirmQueue(_firm));
});
store.getState().identifications.getMappingFor('attachments', document.id).filter(identificationTemp => identificationTemp.status !== 'D').forEach(identificationTemp => {
const _identification = ((_work.get('identification:' + identificationTemp.id) ?? identificationTemp) as Identification).clone();
_identification.status = 'U';
_identification.addedOn = newHRTimestamp();
_identification.addedBy = getCurrentUserId();
_identification.importSource = targetImportSource;
_identification.importId = mergeId;
_identification.attachments = _identification.attachments?.map(id => (id === document.id) ? replaceWith.id : id) || [];

_work.set('identification:' + _identification.id, _identification);
store.dispatch(Actions.IdentificationActions.saveIdentificationQueue(_identification));
});



return document;
}
export function deleteImpactDocument(document: Document) {
const impacts: string[] = [];
const state = store.getState();
const firmLogoImpact = state.firms.getMappingFor('logo', document.id).filter(firm => firm.status !== 'D');
firmLogoImpact.forEach(() => impacts.push('firms'));
const identificationAttachmentsImpact = state.identifications.getMappingFor('attachments', document.id).filter(identification => identification.status !== 'D');
identificationAttachmentsImpact.forEach(() => impacts.push('identifications'));



return util.countDistinct(impacts);
}
